var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgObPromotionIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.333 5.333a1 1 0 100-2 1 1 0 000 2zM9.667 7.667a1 1 0 11-2 0 1 1 0 012 0zM8.805 5.138a.667.667 0 10-.943-.943L5.195 6.862a.667.667 0 10.943.943l2.667-2.667z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.667.667C.93.667.333 1.264.333 2v2.114c0 .177.07.347.196.472L1 5.057c.52.52.52 1.365 0 1.886l-.471.471a.667.667 0 00-.196.472V10c0 .736.597 1.333 1.334 1.333h10.666c.737 0 1.334-.597 1.334-1.333V7.886a.667.667 0 00-.203-.48L13 6.944a1.333 1.333 0 010-1.886l.464-.464a.667.667 0 00.203-.479V2c0-.736-.597-1.333-1.334-1.333H1.667zm10.39 7.219l.276.276V10H1.667V8.162l.276-.276a2.667 2.667 0 000-3.772l-.276-.276V2h10.666v1.838l-.276.276a2.667 2.667 0 000 3.772z",
    fill: "#fff"
  })));
}

export default SvgObPromotionIcon;